import React, { useState } from "react";
import {
  AppBar,
  Box,
  Modal,
  Tab,
  Tabs,
  Typography,
  Stack,
  useTheme,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { EGIconButton } from "../../MainComponents/Button/IconButton/IconButton";
import { NotificationIcon } from "../../Icon";
import Notification from "./Notification";
import "./Notifications.scss";
import { EGBasicSelect } from "../../MainComponents/Select/EGBasicSelect";
/**
 * ## Modal containing notifications
 * @param {json} notificationData
 * @param rechargeData function to reload data
 *
 */
export const Notifications = ({
  notificationData,
  rechargeData,
  unreadNotifications,
}) => {
  const [t] = useTranslation("components");
  const [valueTab, setValueTab] = useState(0);
  const theme = useTheme();

  // Initial state
  const [showNotifications, setShowNotifications] = useState(false);
  const [selectedLength, setSelectedLength] = useState(20);
  // Recarga respetando el límite elegido; `rechargeData` sin argumentos vuelve
  // al default de 20 y perdería la selección del usuario.
  const reload = () => rechargeData(selectedLength);
  // Al abrir se vuelve a consultar: la lista se cargó al entrar a la ruta y
  // pudo quedar vieja (otro usuario movió la denuncia, llegaron notificaciones
  // nuevas).
  const onOpen = () => {
    setShowNotifications(true);
    reload();
  };
  // Close modal notifications
  const onClose = () => {
    setShowNotifications((prev) => !prev);
  };
  // Navigate between tabs
  const hdlChangeTab = (_, newValue) => {
    setValueTab(newValue);
  };
  // Styled Tab
  const TabPanel = (props) => {
    const { children, value, index, ...other } = props;
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`full-width-tabpanel-${index}`}
        aria-labelledby={`full-width-tab-${index}`}
        {...other}
      >
        {value === index && <Box>{children}</Box>}
      </div>
    );
  };

  const a11yProps = (index) => {
    return {
      id: `full-width-tab-${index}`,
      "aria-controls": `full-width-tabpanel-${index}`,
      color: theme.palette.warning.main,
    };
  };
  // Limit of reports to display (options)
  const reportsLengthOpt = [
    { value: 20, label: t("Navbar.last_20") },
    { value: 30, label: t("Navbar.last_30") },
    { value: 50, label: t("Navbar.last_50") },
  ];
  // Select a new
  const handleSelectChange = (e) => {
    const selectedValue = Number(e.target.value);
    setSelectedLength(selectedValue);
    rechargeData(selectedValue);
  };

  return (
    <>
      {/* Bell icon button */}
      <EGIconButton
        iconSize={26}
        title={t("Navbar.notifications")}
        placement="bottom"
        colorHover="primary"
        iconColorHover="white"
        iconColor="secondary"
        iconName="notification"
        onClick={onOpen}
        badgeContent={unreadNotifications}
        max={50}
      />
      <Modal
        open={showNotifications}
        onClose={onClose}
        aria-labelledby="attachment-modal-title"
        aria-describedby="attachment-modal-description"
        sx={{ zIndex: 1054 }}
      >
        <Box
          className="rounded"
          sx={{
            backgroundColor: theme.palette.background.paper,
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            border: `2px solid ${theme.palette.secondary.main}`,
            boxShadow: 24,
            width: { xs: "100%", sm: "70vw" },
            px: 1,
            pb: 1,
          }}
        >
          {/* Close button */}
          <EGIconButton
            iconName="cancel_circle"
            iconColor="primary"
            onClick={onClose}
            sx={{ position: "absolute", top: 20, right: 12 }}
            iconSize={25}
          />
          {/* Title & select */}
          <Stack
            sx={{
              alignItems: "center",
              justifyContent: "space-between",
              flexFlow: "row wrap",
              pt: 0.5,
              px: 0.5,
              pb: { xs: 1, lg: 0 },
            }}
            className="border-bottom"
          >
            <Typography
              variant="h4"
              color="secondary"
              px={1}
              py={2}
              sx={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <NotificationIcon
                size={24}
                className="mx-2 bell shake"
                color={theme.palette.secondary.main}
              />
              {t("Navbar.notifications")}
            </Typography>
            <EGBasicSelect
              sx={{ mx: 5, maxWidth: { xs: "100%", lg: "30%" } }}
              label={`${t("Navbar.limit_notifications")}:`}
              options={reportsLengthOpt}
              value={selectedLength}
              onChange={handleSelectChange}
            />
          </Stack>
          {/* Tabs */}
          <Box
            sx={{
              width: "100%",
              mt: 1,
              borderRadius: "0 0 10px 10px",
            }}
          >
            <AppBar position="static">
              <Tabs
                value={valueTab}
                onChange={hdlChangeTab}
                textColor="inherit"
                variant="fullWidth"
                aria-label="full width tabs notifications"
                sx={{
                  backgroundColor: theme.palette.common.black,
                  "& .MuiTabs-indicator": {
                    fontSize: 5,
                    backgroundColor: theme.palette.warning.main,
                    height: 4,
                  },
                  "& .Mui-selected": {
                    color: theme.palette.warning.light,
                  },
                }}
              >
                <Tab
                  label={t("Navbar.unread")}
                  {...a11yProps(0)}
                  sx={{ fontSize: 14, fontWeight: 600 }}
                />
                <Tab
                  label={t("Navbar.read")}
                  {...a11yProps(1)}
                  sx={{ fontSize: 14, fontWeight: 600 }}
                />
                <Tab
                  label={t("Navbar.all")}
                  {...a11yProps(2)}
                  sx={{ fontSize: 14, fontWeight: 600 }}
                />
              </Tabs>
            </AppBar>

            <TabPanel value={valueTab} index={0} dir={theme.direction}>
              {/* UNREAD section */}
              {notificationData ? (
                <Notification
                  reportsData={notificationData}
                  filterType="unread"
                  onClose={onClose}
                  rechargeData={reload}
                />
              ) : (
                <Typography>{t("Navbar.no_notifications")}...</Typography>
              )}
            </TabPanel>

            <TabPanel value={valueTab} index={1} dir={theme.direction}>
              {/* READ section */}
              {notificationData ? (
                <Notification
                  reportsData={notificationData}
                  filterType="read"
                  onClose={onClose}
                  rechargeData={reload}
                />
              ) : (
                <Typography>{t("Navbar.no_notifications")}...</Typography>
              )}
            </TabPanel>

            <TabPanel value={valueTab} index={2} dir={theme.direction}>
              {/* Show ALL notifications. rechargeData también aquí: marcar una
                  como leída desde Todas debe actualizar el badge igual que
                  desde No leídas. */}
              {notificationData ? (
                <Notification
                  reportsData={notificationData}
                  filterType="all"
                  onClose={onClose}
                  rechargeData={reload}
                />
              ) : (
                <Typography>{t("Navbar.no_notifications")}...</Typography>
              )}
            </TabPanel>
          </Box>
        </Box>
      </Modal>
    </>
  );
};
